import { render, staticRenderFns } from "./RUDataTable.vue?vue&type=template&id=2e3f0ae0&scoped=true"
import script from "./RUDataTable.vue?vue&type=script&lang=js"
export * from "./RUDataTable.vue?vue&type=script&lang=js"
import style0 from "./RUDataTable.vue?vue&type=style&index=0&id=2e3f0ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f0ae0",
  null
  
)

export default component.exports